enum PERMISSION_ACCESS
{
    READ_ONLY = 'READ_ONLY',
    FULL_ACCESS = 'FULL_ACCESS'
}

/**
 * @desc Permission module / system names (match `module.name` in DB).
 */
enum PERMISSION_MODULE
{
    DASHBOARD = 'Dashboard',
    CITATION = 'Citation',
    VIN_SYSTEM = 'VIN System',
    CASE_QUEUE = 'Case Queue',
    PROBATION_SYSTEM = 'Probation System',
    CASE_ACTION = 'Case Action',
    DOCKET = 'Docket',
    DMV_AGENCY_SYSTEM = 'DMV Agency System',
    JURY_SYSTEM = 'Jury System'
}

export { PERMISSION_ACCESS, PERMISSION_MODULE };